import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_p_dropdown = _resolveComponent("p-dropdown")!
  const _component_p_button = _resolveComponent("p-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
    _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_DropZone, {
      maxFiles: 1,
      headers: _ctx.headers,
      acceptedFiles: ['xlsx', 'csv', 'xls'],
      url: _ctx.API_SERVER,
      uploadOnDrop: true,
      onSending: _ctx.sending,
      onRemovedFile: _ctx.onFileRemove,
      maxFileSize: 50000000
    }, null, 8, ["headers", "url", "onSending", "onRemovedFile"]),
    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
    (_ctx.fileId.length && !_ctx.data)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "One moment, your file is being uploaded."))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_p_dropdown, {
              class: "w-full",
              modelValue: this.selectedSheet,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedSheet) = $event)),
              options: _ctx.sheetNames,
              placeholder: "Select Sheet to use",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setColumns()))
            }, null, 8, ["modelValue", "options"])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    (_ctx.data && _ctx.selectedSheet.length && _ctx.columnOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-muted" }, "Pick the corresponding column for each value.", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.name,
              class: "mb-3"
            }, [
              _createElementVNode("label", _hoisted_5, [
                _createTextVNode(_toDisplayString(field.name) + " ", 1),
                (field.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(required)"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_p_dropdown, {
                modelValue: field.targetColumn,
                "onUpdate:modelValue": ($event: any) => ((field.targetColumn) = $event),
                options: _ctx.columnOptions,
                optionLabel: "label",
                filter: "",
                class: "w-full",
                optionValue: "index",
                placeholder: "Select corresponding column",
                showClear: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]))
          }), 128)),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          (_ctx.selectedSheet)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.data[_ctx.selectedSheet].length - 1) + " Rows", 1))
            : _createCommentVNode("", true),
          (_ctx.invalidData)
            ? (_openBlock(), _createBlock(_component_p_button, {
                key: 1,
                disabled: _ctx.disableBtn,
                style: {"float":"right"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.upload(true)))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Force Upload", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_p_button, {
            disabled: _ctx.disableBtn,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.upload()))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Upload", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}